import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getTimeline } from "@/lib/api";
import { IMAGES } from "@/lib/images";
import { Ornament } from "@/components/Ornament";

export default function Timeline() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    getTimeline().then(setEntries).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center max-w-2xl mx-auto">
        <span className="eyebrow">Tarihî Yolculuk</span>
        <h1 className="mt-3 font-[Cinzel] text-4xl sm:text-5xl font-bold text-foreground">
          Bin Yıllık Yolculuk
        </h1>
        <p className="mt-4 text-foreground/75">
          Karahanlı kültür çevresinden UNESCO Dünya Belleği'ne; Dîvân'ın dokuz asırlık izini sürün.
        </p>
        <div className="flex justify-center text-accent mt-6">
          <Ornament className="w-40 h-5" />
        </div>
      </div>

      <div
        className="mt-10 folio-frame rounded-lg overflow-hidden relative"
        data-testid="timeline-map-banner"
      >
        <img
          src={IMAGES.historicMap}
          alt="Dîvân'ın İzinde Bir Zaman Haritası"
          className="w-full h-auto block"
          data-testid="timeline-map-image"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#1F1510]/80 to-transparent" />
        <div className="absolute bottom-4 left-5 right-5 text-[#F5EFEB]">
          <p className="font-[Cinzel] text-xl sm:text-2xl drop-shadow">Dîvân'ın İzinde Bir Zaman Haritası</p>
        </div>
      </div>

      <div className="mt-12 relative">
        <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-border sm:-translate-x-1/2" />
        <div className="space-y-8">
          {entries.map((e, i) => (
            <motion.div
              key={e.id}
              data-testid={`timeline-entry-${e.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5 }}
              className={`relative pl-12 sm:pl-0 sm:w-1/2 ${
                i % 2 === 0 ? "sm:pr-10" : "sm:ml-auto sm:pl-10"
              }`}
            >
              <span
                className={`absolute top-3 w-4 h-4 rounded-full bg-primary border-2 border-background left-[9px] sm:left-auto ${
                  i % 2 === 0 ? "sm:-right-2" : "sm:-left-2"
                }`}
              />
              <div className="card-hover rounded-lg border border-border bg-card p-6">
                <span className="eyebrow">{e.year}</span>
                <h3 className="mt-2 font-[Cinzel] text-xl font-semibold text-foreground">{e.title}</h3>
                <p className="mt-2 text-foreground/75 leading-relaxed">{e.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
